import {Component, Input, EventEmitter} from '@angular/core';
import {Category} from "./category";
import {Query} from "./query";
import {CategoryDataService} from "./category-data.service";

@Component({
  selector: 'category-item',
  template: `
    <div class="ci-block" [ngClass]="{'largeMenu': category.largeMenu==true}">
      <div class="edgeBlock" [ngClass]="{'iconLink': category.link}">
        <i class="fa fa-chevron-right" *ngIf="!category.link"></i>
        <img class="link" src="./assets/images/icons/aci/{{category.icon}}" alt="Open external document" *ngIf="category.link"/>  
      </div>
        
        
        
      <img src="./assets/images/icons/aci/{{category.icon}}" alt="Category icon"/>
      <div class="ci-text" *ngIf="!category.largeMenu">{{category.name}}</div>
        
    </div>
  `
  //styleUrls: ['../app.css']

})

export class CategoryItemComponent {

  @Input() label: string;
  @Input() value: string;
  @Input() ti: string;

  @Input() category: Category;

  constructor(private categoryService: CategoryDataService){

  }





  }



// WEBPACK FOOTER //
// ./src/app/category/category-item.component.ts